<div class="navbar-collapse collapse" id="navbarCollapse">
  @if (startBookingMenu) {
  <ul class="navbar-nav navbar-nav-scroll me-auto">
    <li ngbDropdown class="nav-item dropdown">
      <a ngbDropdownToggle class="nav-link dropdown-toggle arrow-none rounded px-3 py-3 py-xl-0 flex-centered gap-1"
        id="categoryMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="me-auto items-center gap-1">
          <i class="fa-solid fa-suitcase-rolling"></i>
          Travelers
        </span>
        <i class="fa-solid fa-angle-down" style="font-size: small"></i>
      </a>
      <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="categoryMenu">
        @for (item of bookingHomeMenuItems; track $index) {
        <li class="mb-1">
          <a [routerLink]="item.url" [class]="
                  'dropdown-item bg-light-hover d-flex align-items-center rounded p-2'
                ">
            <div class="icon-md bg-primary bg-opacity-10 rounded text-primary flex-shrink-0">
              <i class="{{ item.icon }}"></i>
            </div>
            <div class="ms-2">
              <h6 class="mb-0">{{ item.label }}</h6>
              <p class="small mb-0 text-body">Small description here</p>
            </div>
          </a>
        </li>
        }
      </ul>
    </li>
  </ul>
  }

  <ul class="navbar-nav navbar-nav-scroll {{ menuClassName }}">
    @for (item of menuItems; track $index) {
    @if (item.children) {
    <horizontal-menu-item-with-children [item]="item" [activeMenuItems]="this.activeMenuItems" [level]="1"
      [itemClassName]="'nav-item'" [linkClassName]="
            'nav-link arrow-none d-flex align-items-center gap-1 justify-content-between'
          " />
    } @else {
      <horizontal-menu-item
        [item]="item"
        [level]="1"
        [itemClassName]="'nav-item'"
        [linkClassName]="'nav-link arrow-none d-flex align-items-center gap-1 justify-content-between' + getActiveClass(item)"
      />
    }
    }

    @if (showContactPages) {
    <li class="nav-item">
      <a class="nav-link" routerLink="/pages/contact">Contact Us</a>
    </li>
    }
  </ul>
</div>
